
import createLink from '../../../../../libs/createLink';
import Drawer from '../../../../components2/Drawer/Drawer';
import Button, { BUTTON_VARIANTS } from '../../../../components2/UI/Button/Button';
import './DrawerAvatar.scss';
import avatarImg from './avatars.jpg';

const DrawerAvatar = ({ open,currentUser, handleClose }) => {
    return (
        <Drawer
            small
            open={open} 
            handleClose={handleClose} 

            >
            <div className='drawer-avatar'>
                <img src={avatarImg} alt="Location" style={{width:240, height:'auto'}}/>
                <p>Vous voulez apparaitre dans les membres ? Mettez un avatar.</p>
                <Button full variant={BUTTON_VARIANTS.REVERSE} style={{marginBottom:'12px'}} isLink to={createLink('userMe', currentUser)}>Mettre un avatar</Button>
                <Button onClick={handleClose} full>Plus tard</Button>
            </div>
        </Drawer>
    )
}

export default DrawerAvatar;